import { render, staticRenderFns } from "./hotText.vue?vue&type=template&id=cc2d3f6a&"
import script from "./hotText.vue?vue&type=script&lang=js&"
export * from "./hotText.vue?vue&type=script&lang=js&"
import style0 from "./hotText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports